import EducationTypeService from '../../services/education-type.service'
import { SET_ACCOUNT_EDUCATION_TYPES, SET_PUBLIC_EDUCATION_TYPES } from './'

const setAccountEducationTypes = (payload: any) => {
	return async (dispatch: any) => {
		await EducationTypeService.getEducationTypes(payload)
			.then((response) => {
				dispatch({
					type: SET_ACCOUNT_EDUCATION_TYPES,
					response: response,
				})
			})
			.catch((error) => console.log(error))
	}
}

const setPublicEducationTypes = (payload: any) => {
	return async (dispatch: any) => {
		await EducationTypeService.getEducationTypes(payload)
			.then((response) => {
				dispatch({
					type: SET_PUBLIC_EDUCATION_TYPES,
					response: response,
				})
			})
			.catch((error) => console.log(error))
	}
}

export { setAccountEducationTypes, setPublicEducationTypes }
